<template>
  <div
    :id="id"
    class="roomie-accordion"
    :class="{
      disabled: disabled,
    }">
    <div
      class="roomie-accordion__header"
      :data-lh-id="trackingLhId"
      @click="toggleOpen">
      <template v-if="!$slots.header">
        <span
          v-if="icon"
          class="roomie-icon roomie-accordion__icon">
          <slot name="icon" />
        </span>

        <div
          class="roomie-accordion__information pointer-events-none"
          :class="{ 'no-icon': !icon }">
          <p class="roomie-accordion__title">
            {{ title }}
          </p>
          <p
            v-if="description"
            class="roomie-accordion__description pointer-events-none">
            {{ description }}
          </p>
        </div>
        <span class="roomie-icon roomie-accordion__icon roomie-accordion__icon--action">
          <ChevronUpIcon
            class="transition-all"
            :style="{
              transform: isCurrentlyOpen ? 'rotate(0)' : 'rotate(180deg)'
            }" />
        </span>
      </template>
      <slot name="header" />
    </div>

    <transition
      name="accordion"
      appear>
      <div
        v-if="isCurrentlyOpen"
        class="roomie-accordion__content">
        <slot name="content" />
      </div>
    </transition>
  </div>
</template>

<script>
import ChevronUpIcon from '../../assets/icons/chevron-up.svg'

export { VARIANT } from './utils'

export default {
  name: 'RoomieAccordion',
  components: {
    ChevronUpIcon
  },
  props: {
    id: {
      type: String,
      required: true
    },
    icon: {
      type: [String, Object],
      default: ''
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    isInitiallyOpen: {
      type: Boolean,
      required: false,
      default: false
    },
    isOpen: {
      type: Boolean,
      required: false,
      default: false
    },
    variant: {
      type: String,
      default: ''
    },
    trackingLhId: {
      type: String,
      default: null
    },
  },
  data: function () {
    return {
      isCurrentlyOpen: this.isInitiallyOpen || this.isOpen,
      disabled: this.variant === 'disabled'
    }
  },
  mounted() {
    this.$emit('isContentOpen', this.isCurrentlyOpen)
  },
  methods: {
    toggleOpen() {
      if (!this.disabled) {
        this.isCurrentlyOpen = !this.isCurrentlyOpen
        this.$emit('isContentOpen', this.isCurrentlyOpen)
      }
    }
  }
}
</script>

<style src="./_index.scss" lang="scss" />
